import { inject } from "@angular/core";
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { RESPONSE } from "src/express.tokens";
import { IS_BROWSER_TOKEN } from "../tokens/is-browser.token";
import { Response } from "express";
import { navigateCrossPlatform } from "src/app/util";
import { LoggerService } from "../service/logger.service";
import { ServerConfigService } from "../service/server-config.service";

export const sitePathGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router: Router = inject(Router);
    const isBrowser: boolean = inject(IS_BROWSER_TOKEN);
    const response: Response|null = inject(RESPONSE, { optional: true });
    const serverConfigService: ServerConfigService = inject(ServerConfigService);
    const loggerService: LoggerService = inject(LoggerService);

    // 網站組成設定
    const serverConfigs = ['home'];
    // 預設路徑
    let defaultPath: string;
    // 預設語系
    let defaultLang: string;
    // 網址中的路徑
    let path: string = route.params['path'];

    // 根據 API 給的組出來 defaultPath 和 defaultLan
    defaultPath = 'home';
    defaultLang = 'zh-tw';

    if (!path) {
      const redirectPaths = [`${isBrowser ? '/' : serverConfigService.baseHref}${defaultPath}`, defaultLang];
      loggerService.info(`無路徑(path: ${JSON.stringify(path)})，轉導至${redirectPaths.join('/')}`);
      navigateCrossPlatform(isBrowser, router, response, redirectPaths);
      return false;
    } else if (serverConfigs.findIndex((v) => v === path) > -1) { // TODO: 有路徑參數 檢查是否在server config裡
      return true;
    } else {
      // 有路徑，但是不在列表中
      const redirectPaths = [`${isBrowser ? '/' : serverConfigService.baseHref}404`];
      loggerService.error(`此 path(${JSON.stringify(path)}) 並不在 server config 裡,\nconfig: ${JSON.stringify(serverConfigs)}\nurl: ${JSON.stringify(route.url)}\n轉導至${redirectPaths.join('/')}`);
      navigateCrossPlatform(isBrowser, router, response, redirectPaths);
      return false;
    }

};
